/**
 * Mapping statique pathname → label de contexte pour la présence Realtime.
 *
 * IMPORTANT : `/dossiers/:id/*` est volontairement absent — il est résolu
 * dynamiquement par `usePresenceBroadcast` qui lit le titre du dossier
 * depuis le cache React Query et publie "Dossier {title}".
 *
 * Routes absentes volontairement :
 * - `/fichiers` et `/assistant-ia` : placeholders désactivés dans `navItems.ts` (`disabled: true`).
 *   À ajouter quand ces modules deviendront actifs.
 *
 * Ordre des regex : les plus spécifiques d'abord (ex: /dossiers/kanban avant /dossiers).
 */
const ROUTE_LABELS: ReadonlyArray<readonly [RegExp, string]> = [
  [/^\/dashboard\/?$/, 'Tableau de bord'],
  [/^\/tickets(\/|$)/, 'Demandes'],
  [/^\/dossiers\/kanban\/?$/, 'Kanban dossiers'],
  [/^\/dossiers\/?$/, 'Dossiers'],
  [/^\/contacts(\/|$)/, 'Répertoire'],
  [/^\/taches(\/|$)/, 'Tâches'],
  [/^\/feuille-de-temps\/?$/, 'Feuille de temps'],
  [/^\/calendrier(\/|$)/, 'Calendrier'],
  [/^\/gmail-inbox(\/|$)/, 'Boite Gmail'],
  [/^\/bibliotheque(\/|$)/, 'Bibliothèque'],
  [/^\/facturation(\/|$)/, 'Facturation'],
  [/^\/stats(\/|$)/, 'Statistiques'],
  [/^\/e-barreau(\/|$)/, 'e-Barreau'],
  [/^\/parametres(\/|$)/, 'Paramètres'],
  [/^\/profil(\/|$)/, 'Profil'],
  [/^\/notifications(\/|$)/, 'Notifications'],
  [/^\/logs(\/|$)/, 'Logs'],
  [/^\/design-system(\/|$)/, 'Design System'],
];

export function getRouteLabel(pathname: string): string {
  for (const [regex, label] of ROUTE_LABELS) {
    if (regex.test(pathname)) return label;
  }
  return '';
}
